import React from 'react';
import './HowToUse.scss';
import step1 from '../../../img/step1.png';
import step2 from '../../../img/step2.png';
import step3 from '../../../img/step3.png';
import step4 from '../../../img/step4.png';

const steps = [
    {
        number: '1',
        title: 'Wpisz dane zmarłej osoby',
        description:
            'Uzupełnij formularz danymi potrzebnymi do przygotowania materiałów. Wszystko trafia w jedno miejsce, bez powtarzania informacji.',
        image: step1,
        alt: 'Widok formularza z danymi osoby zmarłej',
    },
    {
        number: '2',
        title: 'Wybierz materiał do przygotowania',
        description:
            'Zdecyduj, czy potrzebujesz nekrologu, tabliczki, szarfy lub innego wydruku. Aplikacja prowadzi Cię przez kolejne ustawienia.',
        image: step2,
        alt: 'Ekran wyboru rodzaju materiału do wygenerowania',
    },
    {
        number: '3',
        title: 'Dopasuj wygląd i format',
        description:
            'Dostosuj układ, kolory i rozmiar projektu. Podgląd pozwala szybko sprawdzić, czy materiał jest gotowy do akceptacji.',
        image: step3,
        alt: 'Konfiguracja parametrów projektu',
    },
    {
        number: '4',
        title: 'Pobierz lub wydrukuj',
        description:
            'Zapisz plik albo od razu przygotuj go do druku. Ustawienia pozostają zapamiętane, więc kolejny projekt powstaje szybciej.',
        image: step4,
        alt: 'Podsumowanie zamówienia z przyciskiem pobierania',
    },
];

export default function HowToUse() {
    return (
        <section className='HowToUse' id='HowToUse'>
            <div className='HowToUse_wrapper'>
                <div className='HowToUse_content'>
                    <div className='HowToUse_intro'>
                        <span className='HowToUse_kicker'>Instrukcja</span>
                        <h1 className='HowToUse_title'>Jak działa aplikacja?</h1>
                        <p className='HowToUse_lead'>
                            Nekrodruk prowadzi użytkownika przez cały proces: od wprowadzenia danych, przez wybór materiału, aż po gotowy plik
                            do zapisu lub druku.
                        </p>
                    </div>

                    <ol className='HowToUse_steps'>
                        {steps.map((step) => (
                            <li key={step.number} className='HowToUse_step'>
                                <div className='HowToUse_stepText'>
                                    <div className='HowToUse_stepHeader'>
                                        <span className='HowToUse_stepNumber'>{step.number}</span>
                                        <h2 className='HowToUse_stepTitle'>{step.title}</h2>
                                    </div>
                                    <p className='HowToUse_stepDescription'>{step.description}</p>
                                </div>
                                <div className='HowToUse_stepImage'>
                                    <img src={step.image} alt={step.alt} loading='lazy' />
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
}
